import { render, staticRenderFns } from "./DocumentTypeView.vue?vue&type=template&id=3f2f999a"
import script from "./DocumentTypeView.vue?vue&type=script&lang=js"
export * from "./DocumentTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports